<template>
  <template v-if="useStack">
    <FaIcon
      class="fa-stack-1x"
      color="white"
      :icon="['fas', 'circle']"
      :transform="positionTransform('shrink-4')"
    />
    <FaIcon
      class="fa-stack-1x"
      color="black"
      :icon="['fas', 'circle']"
      :transform="positionTransform('shrink-5')"
    />
    <FaIcon
      class="fa-stack-1x"
      color="white"
      :icon="['fas', icon]"
      :transform="positionTransform('shrink-9')"
    />
  </template>
  <template v-else>
    <FaIcon
      color="white"
      :icon="['fas', 'circle']"
      :transform="positionTransform('shrink-4')"
    />
    <FaIcon
      color="black"
      :icon="['fas', 'circle']"
      :transform="positionTransform('shrink-5')"
    />
    <FaIcon
      color="white"
      :icon="['fas', icon]"
      :transform="positionTransform('shrink-9')"
    />
  </template>
</template>

<script setup lang="ts">
import { faChartSimple, faMicrophone } from '@fortawesome/pro-solid-svg-icons';
import { library } from '@fortawesome/fontawesome-svg-core';

library.add(faMicrophone);
library.add(faChartSimple);

interface BadgeIconProps {
  icon: string;
  position?: 'left' | 'right';
  useStack?: boolean;
}

const { icon, position = 'right', useStack = true } = defineProps<BadgeIconProps>();

const positionTransform = (baseTransform: string): string => {
  const positionOffset = position === 'left' ? 'left-8 down-6' : 'right-8 down-6';
  return `${baseTransform} ${positionOffset}`;
};
</script>

